import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(productCardStyles, {
    ...productCardStyles,
    gridContainer: {
        gap: 0,
        css: css`
            padding: 0 0;
            border: 1px solid #e1e7ed;
            border-radius: 10px;
            margin-bottom: 20px;
            /*padding-bottom: 10px;*/
            min-width: 320px; /* prevent overlap with second column */
            &:hover {
                border: 1px solid #316fb2;
            }
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 3, 3],
        css: css`
            padding-right: 20px;
            > div {
                a {
                    margin-top: 10px !important;
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 9, 9],
    },
    infoGridItem: {
        width: [12, 11, 12, 7, 7],
        css: css`
            & > :first-child {
                position: relative;
                div[class^="InventoryMessage"] {
                    position: absolute;
                    left: 12px;
                    ${({ theme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                left: 0px;
                            `,
                            css`
                                left: 0px;
                            `,
                            null,
                            null,
                            null,
                        ])},
                }
            }
        `,
    },
    actionsGridItem: {
        width: [11, 6, 12, 4, 4],
        css: css`
            flex-direction: column;
            position: relative;
            margin-top: 10px !important;
            & > :nth-child(1) {
                padding: 0 !important;
            }
            & > :nth-child(2) {
                padding: 12px 0 0px 0 !important;
                width: 100%;
            }
            button[data-test-selector^="actionsAddToCart"] {
                border-radius: 8px !important;
                margin-top: 8px;
            }
            button[data-test-selector^="actionsAddToList"] {
                position: inherit;
                bottom: 0;
                margin-top: 0.7rem;
                padding: 0;
            }
        `,
    },
});
